import { render, staticRenderFns } from "./shareBtn.vue?vue&type=template&id=6a13ca8e&scoped=true&"
import script from "./shareBtn.vue?vue&type=script&lang=js&"
export * from "./shareBtn.vue?vue&type=script&lang=js&"
import style0 from "./shareBtn.vue?vue&type=style&index=0&id=6a13ca8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13ca8e",
  null
  
)

export default component.exports